export default class GetUsersRequest {
    public showDeleted: boolean = false;

    public showExpired: boolean = false;

    public roleNames: string[] = [];
}